// Modules
import React from 'react';
import _ from 'lodash';

import CompanySelector from 'components/widgets/selectors/company-selector';
import Popover from 'components/widgets/overlays/popover';
import TicketSelector from 'components/widgets/selectors/ticket-selector';

import * as actions from './actions';

export default class TimerRelations extends React.Component {
  constructor() {
    super();

    this.state = {};
    this.selectCompany = this.selectCompany.bind(this);
    this.selectTicket = this.selectTicket.bind(this);
  }

  selectCompany(company) {
    const { timer } = this.props;

    actions.update({ ...timer, company, ticket: null });
    this.setState({ selecting: 'Ticket' });
  }

  selectTicket(ticket) {
    const { timer } = this.props;

    actions.update({ ...timer, ticket });
    this.setState({ selecting: null });
    this.popover.hide();
  }

  render() {
    const { timer } = this.props;
    const { selecting } = this.state;

    const ticket = _.get(timer, 'ticket.description');
    const company = _.get(timer, 'company.nickname');
    const archived = timer.status === 'Archived';
    
    if (archived) {
      return (
        <div className="d-flex">
          <span className="badge badge-light text-silver">{company || 'no company'}</span>
          <span className="badge badge-light text-silver">{ticket || 'no ticket'}</span>
        </div>
      );
    }

    const companyTrigger = (
      <div>
        { company && <a onClick={() => this.setState({ selecting: 'Company' })} className="badge badge-dark text-white">{company}</a> }
        { !company && <a onClick={() => this.setState({ selecting: 'Company' })} className="badge badge-secondary text-clouds">add company</a> }
        { ticket && <a onClick={() => this.setState({ selecting: 'Ticket' })} className="badge badge-dark text-white ml-2">{ticket}</a>}
        { company && !ticket && <a onClick={() => this.setState({ selecting: 'Ticket' })} className="badge badge-secondary text-clouds ml-2">add ticket</a>}
      </div>
    );

    return (
      <div className="d-flex">
        <Popover
          id={`timer-company-select-${timer.uuid}`}
          className="popover-no-padding"
          trigger={companyTrigger}
          title={`Select ${selecting}`}
          onExited={() => this.setState({ selecting: null })}
          ref={(popover) => { this.popover = popover; }}
          rootClose
        >
          { selecting === 'Company' && <CompanySelector onSelect={this.selectCompany} /> }
          { selecting === 'Ticket' && company && <TicketSelector onSelect={this.selectTicket} company={timer.company} /> }
        </Popover>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/modules/timers/timer-relations.js